import {FilterVariant, IAppliedFilter, IToggleFilterConfig} from "@/app/models/auctor";

export default function FilterToggle({filterConfig, appliedFilter, handleChange, variant = "default"}: {
    filterConfig: IToggleFilterConfig,
    appliedFilter: IAppliedFilter,
    handleChange: any,
    variant?: FilterVariant,
}) {
    const onChange = (newValue: any) => {
        handleChange(appliedFilter, newValue);
    }

    const currentValue = appliedFilter.value ?? ''
    const unselectedClass = variant === "tool"
        ? 'border-rm-gray-light bg-rm-gray-rule hover:border-rm-gray'
        : 'border-rm-gray-light hover:border-rm-gray'
    const options = [
        {label: filterConfig.left_label, value: filterConfig.left_value},
        {label: filterConfig.right_label, value: filterConfig.right_value},
    ]

    return (
        <div className="flex w-full gap-2">
            {options.map((option) => {
                const isSelected = currentValue === option.value
                return (
                    <button
                        key={String(option.value)}
                        type="button"
                        onClick={() => onChange(option.value)}
                        className={`flex-1 min-h-12 p-2 rounded-lg border-2 transition-all duration-300 text-pale font-semibold cursor-pointer ${isSelected ? 'border-rm-blue' : unselectedClass}`}
                    >
                        {option.label}
                    </button>
                )
            })}
        </div>
    )
}
